import { Link } from "@inertiajs/react"
import { cn } from "@/lib/utils"

export type ClipsSubTab = "browse" | "enrichments_log"

export function ClipsSubTabs({
  active,
  awaitingReviewCount,
}: {
  active: ClipsSubTab
  awaitingReviewCount: number
}) {
  return (
    <div className="border-b border-hairline" role="tablist">
      <nav className="-mb-px flex gap-6">
        <Tab href="/clips"                  active={active === "browse"}           label="Browse" />
        <Tab href="/clips/enrichments_log"  active={active === "enrichments_log"}  label="Recent enrichments" count={awaitingReviewCount} />
      </nav>
    </div>
  )
}

function Tab({
  href,
  active,
  label,
  count,
}: {
  href: string
  active: boolean
  label: string
  count?: number
}) {
  return (
    <Link
      href={href}
      role="tab"
      aria-selected={active}
      className={cn(
        "inline-flex items-center gap-2 border-b-2 px-1 py-2 text-sm font-medium no-underline transition-colors",
        active
          ? "border-accent text-accent-display"
          : "border-transparent text-ink-muted hover:border-hairline hover:text-ink-display",
      )}
    >
      {label}
      {count != null && count > 0 && (
        <span
          className={cn(
            "inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full px-1.5 text-[11px] font-semibold",
            active ? "bg-accent-faded text-accent" : "bg-surface text-ink-muted",
          )}
        >
          {count}
        </span>
      )}
    </Link>
  )
}
